<template>
    <div class="prize-visual">
        <div class="waaier">
            <img src="/static/img/lot.png" class="lot" v-for="n in 10" />
        </div>

        <div class="overflow-limiter">
            <img src="/static/img/vakantiepakket.png" class="vakantiepakket" />
        </div>
        <img src="/static/img/vakantiecheque.jpg" class="vakantiecheque" />
        <div class="fake-shadow"></div>
        <img src="/static/img/prize-description.jpg" class="prize-description" />
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax, TweenMax } from '@/vendor';

    export default {
        mounted()
        {
            this.tl = this.getTl();
            TweenMax.set( this.tl, { progress: 1 });
        },

        methods: {
            getTl()
            {
                TweenMax.set( '.lot', { transformOrigin: '50% 300%', x: '-50%', y: '57%' });
                for( let i = 0; i < 10; i++ )
                {
                    TweenMax.set( '.lot:nth-of-type(' + ( i + 1 ) + ')', { rotation: -18.5 + ( 4.111111 * i ) });
                }

                TweenMax.set( '.vakantiecheque', { rotation: -24.84 });

                let tl = new TimelineMax();

                tl.from( '.prize-description, .fake-shadow', 0.2, { y: 30, opacity: 0, ease: Back.easeOut });
                tl.from( '.vakantiepakket', 0.6, { scaleY: 0.5, opacity: 0, y: '90%', ease: Back.easeOut }, 0.1 );

                tl.from( '.waaier .lot', 0.5, { rotation: 0, x: '-25%', opacity: 0, ease: Back.easeOut }, 0.6 );
                tl.from( '.vakantiecheque', 1, { y: '-200%', x: '50%', opacity: 0, rotation: 360, ease: Expo.easeOut }, 1.3 );

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/PrizeVisual.vue